<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Giải đáp kỹ thuật</v-toolbar-title>
          <v-spacer/>
          <FormReply 
            :showDialog="dialogReply" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
        </v-toolbar>
      </template>
      <template v-slot:item.traloi="{ item }">
        <v-chip
          v-if="item.is_late"
          class="ma-2"
          color="pink"
          label
          outlined
          small
        >
          <v-icon left>
            mdi-emoticon-sad-outline
          </v-icon>
          Trễ hạn
        </v-chip>
        <v-chip
          v-else-if="item.status == 1"
          class="ma-2"
          color="success"
          label
          outlined
          small
        >
          <v-icon left>
            mdi-check
          </v-icon>
          Đã trả lời
        </v-chip>
        <v-chip
          v-else
          class="ma-2"
          color="warning"
          label
          outlined
          small
        >
          <v-icon left>
            mdi-clock-outline
          </v-icon>
          Đang chờ
        </v-chip>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{item.custom_created_at}} <span class="pink--text">({{item.created_at_text}})</span>
      </template>
      <template v-slot:item.updated_at="{ item }">
        <div v-if="item.status == 1">
          {{item.custom_updated_at}} 
          <span class="pink--text">({{item.updated_at_text}})</span>
        </div>
        <span v-else>-</span>
      </template>
      <template 
        v-slot:item.actions="{ item }" 
      >
        <template>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                icon
                color="success" 
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  @click="reply(item)"
                >
                  mdi-message-reply-text
                </v-icon>
              </v-btn>
            </template>
            <span>Giải đáp</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import FormReply from '@/views/admin/supports/Reply'
  import { mapState } from 'vuex'
  export default {
    components: {
      FormReply
    },
    props: {
      userId: {
        type: Number,
        default: 0
      }
    },
    data: () => ({
      loading: false,
      dialogReply: false,
      search: '',
      headers: [
        { text: 'Tiêu đề', value: 'tieude' },
        { text: 'Trạng thái', value: 'traloi' },
        { text: 'Ngày hỏi', value: 'created_at' },
        { text: 'Ngày trả lời', value: 'updated_at' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        }
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      items: [],
      editedIndex: -1,
      item: {},
      options: {}
    }),
    computed: {
      ...mapState([
        'authMod'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật'
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    methods: {
      initialize () {
        const app = this;
        const { page, itemsPerPage, type } = app.options;
        let pageNumber = page;
        let user = null;
        if(app.userId){
          user = app.userId;
        }
        let expertId = app.authMod.user.user.info.coso_id;
        let request = {
          params: {
            expertId: expertId,
            size: itemsPerPage,
            page: pageNumber,
            type: type,
            user: user,
            keyword: app.search
          }
        };
        app.loading = true;
        axios.get("api/v1/supports", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
            SystemSevice.logging('systems.Form.onFilePicked', error);
          });
      },
      onConfirmed(item) {
        this.dialog = false
        this.dialogReply = false
        this.initialize()
      },
      onCancelled () {
        this.dialog = false
        this.dialogReply = false
      },
      reply(item) {
        this.editedIndex = this.items.indexOf(item)
        this.item = Object.assign({}, item)
        this.dialogReply = true
      }
    }
  }
</script>